import api from './api';
import type {CompositeAiAnalysis, CompositeSignal, StatusFilter} from '../types/compositeSignal';

/** 查询已持久化的组合信号（只读，供页面轮询） */
export async function getCompositeSignals(
    symbol: string,
    interval: string = '1H',
    limit: number = 30,
    status?: StatusFilter,
    apiKeyId?: number,
): Promise<CompositeSignal[]> {
    const statusParam = status && 'ALL' !== status ? status : undefined;
    const res = await api.get(`/api/v1/composite-signals/${symbol}`, {
        params: {interval, limit, status: statusParam, apiKeyId},
    });
    return res.data?.data ?? [];
}

/** 单条详情（含完整证据链） */
export async function getCompositeSignalDetail(id: number): Promise<CompositeSignal | null> {
    const res = await api.get(`/api/v1/composite-signals/detail/${id}`);
    return res.data?.data ?? null;
}

/**
 * 手动触发聚合，返回本次合成条数
 */
export async function generateCompositeSignals(
    symbol: string,
    interval: string = '1H',
    provider: string = 'OKX',
): Promise<number | null> {
    const res = await api.post(`/api/v1/composite-signals/generate/${symbol}`, null, {
        params: {interval, provider},
    });
    return res.data?.data ?? null;
}

/** 查询组合信号的最新 AI 解读 */
export async function getCompositeSignalAnalysis(id: number): Promise<CompositeAiAnalysis | null> {
    const res = await api.get(`/api/v1/composite-signals/analysis/${id}`);
    return res.data?.data ?? null;
}

/** 触发组合信号 AI 解读（LLM 调用耗时较长，超时 120s） */
export async function analyzeCompositeSignal(id: number): Promise<CompositeAiAnalysis | null> {
    const res = await api.post(`/api/v1/composite-signals/analyze/${id}`, null, {timeout: 120000});
    return res.data?.data ?? null;
}
